const config = {
  routificApi: {
    planningService: {
      url: {
        base: `${import.meta.env.REACT_APP_PLANNING_API}`,
        projects: '/projects/all',
        project: '/projects',
      },
    },
  },
  deliveryTracker: {
    url: import.meta.env.REACT_APP_DELIVERY_TRACKER_URL || (import.meta.env.DEV ? 'http://localhost:3011' : ''),
  },
  thirdParty: {
    google: {
      ssoClientId: `${import.meta.env.REACT_APP_SSO_GOOGLE_CLIENT_ID}`,
    },
    apple: {
      ssoClientId: `${import.meta.env.REACT_APP_SSO_APPLE_CLIENT_ID}`,
      redirectURI: `${import.meta.env.REACT_APP_SSO_APPLE_REDIRECT_URI}`,
    },
    googleToken: import.meta.env.REACT_APP_GMAPS_TOKEN,
    mapboxToken: import.meta.env.REACT_APP_MAPBOX_TOKEN,
    optimizelyToken: import.meta.env.REACT_APP_OPTIMIZELY_TOKEN,
    ipgeolocation: {
      url: 'https://api.ipgeolocation.io/ipgeo',
      token: import.meta.env.REACT_APP_IPGEOLOCATION_TOKEN,
    },
    ablySubscribeKey: import.meta.env.REACT_APP_ABLY_SUBSCRIBE_KEY,
    segment: {
      token: import.meta.env.REACT_APP_SEGMENT_TOKEN,
      // First-party reverse-proxy host (no scheme), e.g. cdp-development.routific.com.
      // When set, analytics.js settings load from <host>/cdn and events POST to <host>/api,
      // so requests are first-party and bypass domain-based ad-blocker lists.
      proxyHost: import.meta.env.REACT_APP_SEGMENT_PROXY_HOST,
    },
    posthog: {
      token: import.meta.env.REACT_APP_POSTHOG_TOKEN,
      enabled: import.meta.env.REACT_APP_ENABLE_POSTHOG === 'true',
      // First-party reverse-proxy host (no scheme), e.g. cdp-development.routific.com.
      // When set, PostHog assets/ingestion route through <host>/ingest instead of
      // *.i.posthog.com, so requests are first-party and bypass domain-based ad-blocker lists.
      proxyHost: import.meta.env.REACT_APP_POSTHOG_PROXY_HOST,
    },
    gleap: {
      token: import.meta.env.REACT_APP_GLEAP_TOKEN,
      usageLimitBot: import.meta.env.REACT_APP_GLEAP_USAGE_LIMIT_BOT,
    },
    sentry: {
      dsn: import.meta.env.REACT_APP_SENTRY_DSN,
      traceSampleRate: Number(import.meta.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE) || 0,
      environment: import.meta.env.REACT_APP_SENTRY_ENVIRONMENT || 'sandbox',
      release: import.meta.env.REACT_APP_SENTRY_RELEASE,
    },
    loggly: {
      token: import.meta.env.REACT_APP_LOGGLY_CUSTOMER_TOKEN,
      tag: import.meta.env.REACT_APP_LOGGLY_TAG,
    },
    stripe: {
      publishableKey: import.meta.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    },
  },
  fullProductUrl: import.meta.env.REACT_APP_FULL_PRODUCT_URL,
  socket: {
    url: {
      jobScheduler: '/jobs-scheduler',
    },
  },
};

export type DataSource = keyof typeof config['routificApi'];

export default config;
